<template>
  <Modal headerType="fail" :visible="visible" @close="handleClickClose">
    <div class="modalContent">
      <div class="title">本次助力已结束，再来一次吧～</div>
      <img class="icon" src="../assets/images/sad-face.png" />
      <div class="okBtn" @click="handleClickOk">
        再次发起助力领券
        <div class="badge">{{ badgeStr }}</div>
      </div>
    </div>
  </Modal>
</template>

<script>
import Modal from './Modal';

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    badgeStr: {
      type: String,
      require: true
    }
  },
  components: {
    Modal
  },
  watch: {
    visible: function(newVal, oldVal) {
      if (newVal && !oldVal) {
        // 埋点
        this.reportExpo();
      }
    }
  },
  methods: {
    handleClickOk() {
      this.$emit('relaunch');
      this.$emit('close');
      this.$emit('reportEvent', {
        event: 'boost_coupon_popup_invite_click',
        module_name: '助力失败弹窗',
        button_name: '再次发起助力领券'
      });
    },
    handleClickClose() {
      this.$emit('close');
      this.$emit('reportEvent', {
        event: 'boost_coupon_popup_invite_click',
        module_name: '助力失败弹窗',
        button_name: '退出icon'
      });
    },
    reportExpo() {
      this.$emit('reportExpoEvent', {
        event: 'boost_coupon_invite_expo',
        module_name: '助力失败弹窗'
      });
    }
  }
};
</script>

<style lang="less" scoped>
.modalContent {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 32px;
  color: #333;
}

.icon {
  margin: 75px 0;
  width: 185px;
  height: 185px;
}

.okBtn {
  position: relative;
  margin-top: 18px;
  margin-bottom: 50px;
  width: 500px;
  height: 100px;
  background: #ff264b;
  border-radius: 50px;
  font-size: 40px;
  color: #ffffff;
  .fc;
  line-height: normal;

  .badge {
    position: absolute;
    top: -30px;
    left: 320px;
    width: 200px;
    height: 44px;
    font-size: 26px;
    color: #ff264b;
    .fc;
    line-height: normal;
    background: center / cover no-repeat
      url('../assets/images/modal-tag-bg.png');
  }
}
</style>
